import type { ReactNode } from 'react'
import { useId, useState } from 'react'
import { MdAdd, MdRemove } from 'react-icons/md'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

type Props = {
  children: ReactNode
}

export const AccordionFilter = ({ children }: Props) => {
  const [isExpand, setIsExpand] = useState(false)
  const id = useId()

  return (
    <Wrapper>
      <Button
        type="button"
        onClick={() => setIsExpand((prev) => !prev)}
        aria-expanded={isExpand}
        aria-controls={id}
      >
        絞り込み
        {isExpand ? <CloseIcon /> : <OpenIcon />}
      </Button>
      <Content id={id}>{children}</Content>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  @media screen and (max-width: 1047px) {
    padding: 0 20px;
  }
`

const Button = styled.button`
  display: none;

  @media screen and (max-width: 1047px) {
    width: 100%;
    height: 50px;
    margin: 0 auto;
    padding: 0 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: bold;
    color: ${theme.colors.textTitle};
    background-color: ${theme.colors.backgroundGrey};
    border: none;
    border-radius: 8px;

    &[aria-expanded='true'] {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    &[aria-expanded='false'] + div {
      height: 0;
      padding-top: 0;
      padding-bottom: 0;
      opacity: 0;
      overflow: hidden;
      pointer-events: none;
    }
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media screen and (max-width: 1047px) {
    transition: 0.3s;
    padding: 26px 22px;
    gap: 24px;
    background: ${theme.colors.backgroundGrey};
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
`

const OpenIcon = styled(MdAdd)`
  font-size: 30px;
  color: ${theme.colors.grey};
`

const CloseIcon = styled(MdRemove)`
  font-size: 30px;
  color: ${theme.colors.grey};
`
